<template>
    <div>
        <!-- Header Background Image -->
		<div class="profile-nav-bg" style="background-image: url('/images/bg-profile.jpg')"></div>
		<!-- / Header Background Image -->

        <div class="search_div">
            <a-row  type="flex" style="width: 50%;">
                <a-input-search placeholder="input search text"   /> 
                <!-- /*@search="onSearch"*/ -->
            </a-row>

        </div>

        <a-row :gutter="24" type="flex" style="margin-top: 100px;">
			<a-col :span="24" class="mb-24">
                <CardReceptionsTable
                    :data="table1Data"
                    :columns="table1Columns"
                ></CardReceptionsTable>
			</a-col>
		</a-row>
    </div>
</template>

<script>
    import CardReceptionsTable from "../components/Cards/CardReceptionsTable.vue";
    const table1Columns = [
		{
			title: 'Visitor',
			dataIndex: 'author',
			scopedSlots: { customRender: 'author' },
		},
		// {
		// 	title: 'FUNCTION',
		// 	dataIndex: 'func',
		// 	scopedSlots: { customRender: 'func' },
		// },
		{
			title: 'STATUS',
			dataIndex: 'status',
			scopedSlots: { customRender: 'status' },
		},
		{
			title: 'Date',
			dataIndex: 'date',
			class: 'text-muted',
		},
		{
			title: 'Time',
			dataIndex: 'time',
			class: 'text-muted',
		},
		// {
		// 	title: 'Action',
		// 	scopedSlots: { customRender: 'editBtn' },
		// 	width: 50,
		// },
	];

	// "Authors" table list of rows and their properties.
	const table1Data = [
		{
			key: '1',
			author: {
				avatar: 'images/face-2.jpg',
				name: 'Michael John',
				email: 'michael@mail.com',
			},
			status: 1,
			date: '23/04/18',
			time: '12:00pm',
		},
		{
			key: '2',
			author: {
				avatar: 'images/face-3.jpg',
				name: 'Alexa Liras',
				email: 'alexa@mail.com',
			},
			status: 0,
			date: '23/12/20',
			time: '12:00pm',
		},
		{
			key: '3',
			author: {
				avatar: 'images/face-1.jpg',
				name: 'Laure Perrier',
				email: 'laure@mail.com',
			},
			status: 1,
			date: '13/04/19',
			time: '12:00pm',
		},
		{
			key: '4',
			author: {
				avatar: 'images/face-4.jpg',
				name: 'Miriam Eric',
				email: 'miriam@mail.com',
			},
			status: 1,
			date: '03/04/21',
			time: '12:00pm',
		},
		{
			key: '5',
			author: {
				avatar: 'images/face-5.jpeg',
				name: 'Richard Gran',
				email: 'richard@mail.com',
			},
			status: 0,
			date: '23/03/20',
			time: '12:00pm',
		},
		{
			key: '6',
			author: {
				avatar: 'images/face-6.jpeg',
				name: 'John Levi',
				email: 'john@mail.com',
			},
			status: 0,
			date: '14/04/17',
			time: '12:00pm',
		},
	];
    export default {
        name: "Receptions",
        components: {
            CardReceptionsTable,
        },
        data(){
            return {
                table1Data: table1Data,
                table1Columns: table1Columns,
            }
        },
    }
</script>

<style lang="scss">
    .search_div{
        display:flex;
        justify-content:center;
        align-items:center;
        margin-top: -150px;

        .ant-input{
            height: 60px !important;
            border-radius: 45px;
        }
    }
</style>